import { MessageBarType } from '@fluentui/react'
import { wrap } from 'comlink'
import { format } from 'date-fns'
import { call, put, select, takeLatest } from 'typed-redux-saga'
import { createAsyncAction } from 'typesafe-actions'
import { pushNotification } from '../../../../../../../../../features/Notifications'
import { downloadUrlAsFile } from '../../../../../../../../../shared/downloads'
import { AppState } from '../../../../../../../../../store'
import {
  createAsyncReducer,
  createAsyncSelectors
} from '../../../../../../../../../store/shared/asyncStore'
import { getAllPagedOdataApiResults } from '../../../../../../../../../store/shared/sagas/odata'
import type { HurdleManagementViewFormattedExportWorker } from './exportFormatted.worker'
import {
  fetchHurdleProgressMeasurements,
  hurdleProgressManagementListUiSelectors
} from './hurdleProgressManagementList'

export const hurdleManagementViewExportFormattedActions = createAsyncAction(
  '@modules/@advisory/@modules/@teams/@modules/@hurdles/@features/@hurdleProgressManagement/@exportFormatted/REQUEST',
  '@modules/@advisory/@modules/@teams/@modules/@hurdles/@features/@hurdleProgressManagement/@exportFormatted/SUCCESS',
  '@modules/@advisory/@modules/@teams/@modules/@hurdles/@features/@hurdleProgressManagement/@exportFormatted/FAILURE'
)<undefined, undefined, Error>()

export const hurdleManagementViewExportFormattedReducer = createAsyncReducer(
  hurdleManagementViewExportFormattedActions
)

const rootSelector = (state: AppState) =>
  state.modules.advisory.modules.teams.modules.hurdles.features
    .hurdleProgressManagementList.hurdleManagementViewExportFormatted
export const {
  getError: getHurdleManagementViewExportError,
  getIsLoading: getIsHurdleManagementViewFormattedExportLoading
} = createAsyncSelectors(rootSelector)

const onExport = function* () {
  try {
    const request = yield* select(
      hurdleProgressManagementListUiSelectors.getOdataRequest
    )
    const results = yield* call(() =>
      getAllPagedOdataApiResults(request, fetchHurdleProgressMeasurements)
    )

    const worker = new Worker(
      new URL('./exportFormatted.worker.ts', import.meta.url)
    )
    const { createAndDownloadHurdleManagementViewFormattedExport } =
      wrap<HurdleManagementViewFormattedExportWorker>(worker)

    const result = yield* call(
      createAndDownloadHurdleManagementViewFormattedExport,
      results
    )

    const filename = `Hurdles Management View Formatted ${format(
      new Date(),
      'MM-dd-yyyy'
    )}.xlsx`
    downloadUrlAsFile(result, filename)
    yield put(hurdleManagementViewExportFormattedActions.success())
  } catch (e: unknown) {
    yield put(hurdleManagementViewExportFormattedActions.failure(e as Error))
  }
}

const onFailure = function* (
  action: ReturnType<typeof hurdleManagementViewExportFormattedActions.failure>
) {
  yield call(pushNotification, {
    message: `Export failed: ${action.payload.message}`,
    type: MessageBarType.error
  })
}

export const hurdleManagementViewExportFormattedSagas = [
  () =>
    takeLatest(hurdleManagementViewExportFormattedActions.request, onExport),
  () =>
    takeLatest(hurdleManagementViewExportFormattedActions.failure, onFailure)
]
